export class PayerForCenterRequest{
    centerId:string;
    payerCode:string;

    constructor(centerId:string, payerCode:string){
        this.centerId = centerId;
        this.payerCode = payerCode;
    }
}